import {
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { FaCheck, FaEye } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Encabezado } from '../../../Components/Encabezado/Encabezado';

import { CleaningServices } from '@mui/icons-material';
import { EquiposPendientesModal } from '../../../Components/Acciones/Equipos/EquiposPendientesModal';
import Loading from '../../../Components/Modals/Loading/Loader';
import {
  fetchGetAccionesEquiposInsumos,
  fetchGetAccionesEquiposInsumosCount,
  fetchGetEstadosEquipos,
  selectEquiposCount,
  selectIsLoading,
  selectListaEquiposInsumos,
  selectListaEstadoEquipos,
} from '../../../redux/Acciones/AccionesSlice';

const style = {
  cellStyle: {
    fontWeight: 'bold',
  },
  typographyFiltro: {
    fontSize: 13,
    fontWeight: 'bold',
    mr: 2,
    mt: 1,
  },
};

const defaultValueFilter = {
  estado: 0,
  nombre: '',
};

export const SolicitudEquipo = () => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-STATE
  const [filtro, setFiltro] = useState(defaultValueFilter);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);
  const [estadoEquiposState, setEstadoEquiposState] = useState([]);
  const [refreshListState, setRefreshListState] = useState(false);
  const [openAsignacionesPendientes, setOpenAsignacionesPendientes] = useState({ open: false, asignacionesPendientes: {} });

  // ? HOOK-SELECTOR
  const equipos = useSelector(selectListaEquiposInsumos);
  const equiposCount = useSelector(selectEquiposCount);
  const estados = useSelector(selectListaEstadoEquipos);
  const isLoading = useSelector(selectIsLoading);

  // * FUNCION PARA REFRESCAR LISTAS
  const refreshList = () => {
    dispatch(fetchGetAccionesEquiposInsumos({ ...filtro, index: skipRow, itemsPerPage: rowsPerPage }));
    dispatch(fetchGetAccionesEquiposInsumosCount({ ...filtro, index: skipRow, itemsPerPage: rowsPerPage }));
  };

  // ? HOOK-EFFECT
  useEffect(() => {
    dispatch(fetchGetEstadosEquipos());
  }, [dispatch]);

  useEffect(() => {
    refreshList();
  }, [dispatch, filtro.estado, skipRow, rowsPerPage]);

  useEffect(() => {
    if (refreshListState) {
      refreshList();
      setRefreshListState(false);
    }
  }, [refreshListState]);

  useEffect(() => {
    setEstadoEquiposState([{ id: 0, descripcion: 'Seleccionar una opción' }, ...estados]);
  }, [dispatch, estados]);

  // * FUNCION DE ESTILOS PARA CAMBIAR COLORES DE LETRA SEGUN EL ESTADO.
  const colorStatus = (id = 0) => {
    const colors = {
      1: '#FFBD00',
      2: '#169C00',
      3: '#2EA9B3',
    };

    return { color: colors[id] || 'black', fontWeight: 'bold' };
  };

  // * FUNCIONES DE PAGINACION.
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setPage(0);
      refreshList();
    }
  };

  // * FUNCION PARA LIMPIAR FILTRO,
  const cleanFilter = () => {
    setFiltro(defaultValueFilter);
    setPage(0);
    setSkipRow(0);
    setRowsPerPage(25);
    setRefreshListState(true);
  };

  // * FUNCION PARA ACTUALIZAR EL STATE DE FILTRO.
  const saveFiltro = (name, data) => setFiltro({ ...filtro, [name]: data });

  return (
    <Encabezado title="Solicitud de Equipos e Insumos">
      <Paper elevation={2} sx={{ p: 1, m: 2 }}>
        <Paper elevation={3}>
          <Grid mt={1} container alignItems="center" justifyContent="center" p={2}>
            <Grid item xs={5} display="flex">
              <Typography sx={style.typographyFiltro}>Área</Typography>
              <div style={{ width: '80%' }}>
                <Select
                  classNamePrefix="select"
                  isSearchable
                  placeholder="Seleccionar Área Organizacional"
                  options={estadoEquiposState}
                  getOptionLabel={(option) => option.descripcion}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => saveFiltro('estado', e.id)}
                  value={estadoEquiposState.find((x) => x.id === filtro.estado)}
                />
              </div>
            </Grid>
            <Grid item xs={5} display="flex">
              <Typography sx={style.typographyFiltro}>Empleado</Typography>
              <TextField
                value={filtro.nombre}
                onChange={(e) => saveFiltro('nombre', e.target.value)}
                sx={{ width: '80%' }}
                onKeyDown={handleKeyDown}
              />
            </Grid>
            <Grid item xs={1}>
              <Button id="btn-clean-empleados" variant="contained" color="error" type="button" title="Limpiar filtros" onClick={() => cleanFilter()}>
                <CleaningServices />
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table elevation={3}>
            <TableHead>
              <TableRow>
                <TableCell sx={style.cellStyle}>Empleado</TableCell>
                <TableCell sx={style.cellStyle}>Usuario</TableCell>
                <TableCell sx={style.cellStyle}>Correo</TableCell>
                <TableCell sx={style.cellStyle}>Transdoc</TableCell>
                <TableCell sx={style.cellStyle}>PC</TableCell>
                <TableCell sx={style.cellStyle}>Impresora</TableCell>
                <TableCell sx={style.cellStyle}>Flota</TableCell>
                <TableCell sx={style.cellStyle}>Teléfono Fijo</TableCell>
                <TableCell sx={style.cellStyle} align="center">
                  Estado
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {equipos.length > 0 ? (
                equipos.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.nombreEmpleado}</TableCell>
                    <TableCell>{item.usuario ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.correo ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.transdoc ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.pc ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.impresora ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.flota ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell>{item.telefonoFijo ? <FaCheck /> : 'N/A'}</TableCell>
                    <TableCell sx={colorStatus(item.estado.id)} align="center">
                      {item.estado.descripcion}
                    </TableCell>
                    <TableCell>
                      {item.asignacionesPendientes ? (
                        <IconButton
                          onClick={() => setOpenAsignacionesPendientes({ open: true, asignacionesPendientes: item.asignacionesPendientes })}
                        >
                          <FaEye color="#003876" />
                        </IconButton>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableCell colSpan={9} align="center">
                  No hay registros
                </TableCell>
              )}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={equiposCount}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Paper>

      <Loading open={isLoading} />
      <EquiposPendientesModal open={openAsignacionesPendientes} setOpen={setOpenAsignacionesPendientes} />
    </Encabezado>
  );
};
